/* eslint-disable no-irregular-whitespace */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable spaced-comment */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/aria-props */
/* eslint-disable jsx-a11y/role-has-required-aria-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useContext, useState } from "react";
import { NumericFormat } from "react-number-format";
import { isMobile } from "react-device-detect";
import { popupWin } from "components/PopUps";
import { UmbracoContext, UmbracoStep } from "components/Umbraco/UmbracoContext";
import utils from "utils";
import FusionCharts from "./FusionCharts";
import {
  Between,
  Button,
  InnerBig,
  LabelSmall,
  LabelSubTitle,
  Line,
  Row,
} from "meitav-uikit";
import PopUp from "./Popup";
import PopUpBitcoin from "./PopupBitcoin";

const { UmbracoUtills } = utils;

export default function Section2(props) {
  const resource = UmbracoStep(useContext(UmbracoContext).resource, "Section2");
  const resourceContact = UmbracoStep(
    useContext(UmbracoContext).resource,
    "PopUpContact"
  );
  const resourcePopUp = UmbracoStep(
    useContext(UmbracoContext).resource,
    "PopUpBitcoin"
  );
  const resourceLobby = useContext(UmbracoContext).resource.properties;
  const investPolicyGUID = localStorage.getItem("investPolicyGUID");

  const moveDigitalJoin = () => {
    if (
      props.lobbyDetailsData.sectorCode == 6 &&
      props.lobbyDetailsData.riskLevel < 5
    ) {
      setOpen(true);
    } else {
      window.dataLayer.push({
        event: "PM - ivestment",
        eventInfo: {
          action_screen: window.location.pathname,
          process_level: "הרכב תיק ההשקעות",
          action_name: "המשך מוצלח של שלב הרכב תיק ההשקעות",
        },
      });

      window.open("/JoinPersonalDetails", "_self");
    }
  };
  const [open, setOpen] = useState(false);
  const [typePopUp, setTypePopUp] = useState();
  const handleClose = () => {
    setOpen(false);
  };

  const sumDepositTextFunction = (sumDeposit) => (
    <div className="">
      <NumericFormat
        className="depositSum"
        value={` ${Number.parseFloat(sumDeposit)}`}
        displayType="text"
        thousandSeparator
        prefix="₪"
      />
    </div>
  );
  const [openHerkevTik, setHerkevTik] = useState(false);

  const [openHerkevTikafik, setHerkevTikafik] = useState("");

  const [herkevTikText, setHerkevTikText] = useState("");
  const [herkevTikTitle, setHerkevTikTitle] = useState("");
  const [herkevTikCircleClickcss, setHerkevTikCircleClickcss] = useState("");

  const contactUsClick = () => {
    //const type = "contact"; // { popUpType: 'contact' };
    // setTypePopUp(type);
    // setOpen(true);
    let obj = {};
    obj.type = "contactUs";
    obj.resource = resourceContact;
    obj.className = "contactUs";
    obj.flagSrc = "lobby";
    popupWin(obj);
  };
  const herkevTikClick = (event, val, item) => {
    setHerkevTik(true);
    setHerkevTikafik(item);
    setHerkevTikText(val.hebrewNameText);
    setHerkevTikTitle(val.afikName);
    setHerkevTikCircleClickcss(` herkevTikCircleClick`);
  };
  const changeProfile = async () => {
    window.dataLayer.push({
      event: "PM - ivestment",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "הרכב תיק ההשקעות",
        action_name: "אישור שינוי הרכב התיק",
      },
    });

    const result = await rest.get(
      `/api/Manager/ChangeUserPorfile?guid=${investPolicyGUID}`
    );
    window.open(`/CustomerInvestPolicy`, "_self");
  };
  return (
    <Row className="section2">
      <InnerBig className="wrapper">
        {props.lobbyDetailsData.sectorNoRiskLevel ? (
          <Row className={`${isMobile ? "containerMobile" : ""}`}>
            <div>
              <Between>
                <div className="borderSection" />
                <div className="title">
                  <LabelSubTitle className="h1Accibility">
                    {UmbracoUtills.getParsedHtmlValueByKey(
                      resource,
                      "titleSector" + props.lobbyDetailsData.sectorCode
                    )}
                  </LabelSubTitle>
                </div>
                <div className="borderSection" />
              </Between>

              <div>
                {UmbracoUtills.getParsedHtmlValueByKey(
                  resource,
                  "descSector" + props.lobbyDetailsData.sectorCode
                )}
              </div>
              <Line>
                <div
                  className={`${
                    isMobile ? "buttonDigitalJoinMobile" : ""
                  } buttonDigitalJoin`}
                >
                  <Button
                    variant="contained"
                    onClick={moveDigitalJoin}
                    text={UmbracoUtills.getParsedHtmlValueByKey(
                      resourceLobby,
                      "buttonDigitalJoin"
                    )}
                  ></Button>
                </div>
                <div className={`${isMobile ? "" : "mr-2"} buttonContactUs`}>
                  <Button
                    variant="outlined"
                    onClick={contactUsClick}
                    text={UmbracoUtills.getParsedHtmlValueByKey(
                      resourceLobby,
                      "buttonContactUs"
                    )}
                  ></Button>
                </div>
              </Line>
            </div>
          </Row>
        ) : (
          <Row className={`${isMobile ? "containerMobile" : ""}`}>
            <Between>
              <div className="borderSection " />
              <div className="title">
                <LabelSubTitle className="h1Accibility">
                  {UmbracoUtills.getParsedHtmlValueByKey(resource, "title")}
                </LabelSubTitle>
              </div>
              <div className="borderSection" />
            </Between>
            <Line>
              <Row className="herkevTikGroup">
                <Row>
                  <Line role="radiogroup">
                    {props.lobbyDetailsData.calculetedHerkevTik.map(
                      (item, i) => (
                        <Line
                          className={`${
                            openHerkevTik && i == openHerkevTikafik
                              ? herkevTikCircleClickcss
                              : ""
                          } herkevTik-${i} ${
                            isMobile ? "" : i == 0 || i % 2 == 0 ? "ms-3" : ""
                          }`}
                          key={i}
                          tabIndex={i === 0 ? 0 : -1}
                          onClick={(event) => herkevTikClick(event, item, i)}
                          role="radio"
                          aria-checked={
                            openHerkevTik && i == openHerkevTikafik
                              ? "true"
                              : "false"
                          }
                        >
                          <div
                            className={`herkevTikCircle ms-1 ${
                              openHerkevTik && i == openHerkevTikafik
                                ? "herkevTikClick"
                                : ""
                            } `}
                          />
                          <div
                            className={`${
                              isMobile ? "pr-0 text-center" : ""
                            } herkevTikPercen col-md-4 p-0 col-4`}
                          >
                            {`${item.totalAfikPercent}%`}
                          </div>
                          <div
                            className={`${
                              openHerkevTik ? "" : "herkevTikText"
                            }  col-md-8 p-0 col-6`}
                          >
                            {item.afikName}
                          </div>
                        </Line>
                      )
                    )}
                  </Line>
                </Row>
                <div>
                  {openHerkevTik ? (
                    <div tabIndex="0">
                      <div className="title2 text-right">
                        <LabelSubTitle className="h1Accibility">
                          {herkevTikTitle}
                        </LabelSubTitle>
                      </div>
                      <div>{herkevTikText}</div>
                    </div>
                  ) : null}
                  <Line>
                    <div
                      className={`${
                        isMobile ? "buttonDigitalJoinMobile mb-3 mt-5" : ""
                      } buttonDigitalJoin ms-md-3 col-md-5 p-0`}
                    >
                      <Button
                        variant="contained"
                        onClick={moveDigitalJoin}
                        text={UmbracoUtills.getParsedHtmlValueByKey(
                          resourceLobby,
                          "buttonDigitalJoin"
                        )}
                      ></Button>
                    </div>
                    <div
                      className={`${isMobile ? "" : "mr-2"} buttonContactUs`}
                    >
                      <Button
                        variant="outlined"
                        onClick={contactUsClick}
                        text={UmbracoUtills.getParsedHtmlValueByKey(
                          resourceLobby,
                          "buttonContactUs"
                        )}
                      ></Button>
                    </div>
                  </Line>
                </div>
              </Row>
              <Row className="fusionCharts">
                <FusionCharts
                  herkevTik={props.lobbyDetailsData.calculetedHerkevTik}
                  sumDepositText={
                    //{sumDepositTextFunction( props.lobbyDetailsData.depositSum)}
                    `₪
                 ${Number.parseFloat(props.lobbyDetailsData.depositSum)
                   .toFixed(0)
                   .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} `
                  }
                  pieRadius={`${isMobile ? "70%" : "80%"}`}
                  sliceClickHandle={(eventObj, argsObj) => {
                    const index = eventObj?.data?.dataIndex;
                    const item =
                      props.lobbyDetailsData.calculetedHerkevTik[index];
                    herkevTikClick(eventObj, item, index);
                  }}
                />
              </Row>
            </Line>
          </Row>
        )}
      </InnerBig>
      <PopUp
        openProp={open}
        handleClose={handleClose}
        type={typePopUp}
        // next={}
        // setSnapshot={setSnapshot}
        // setStepNumber={setStepNumber}
      />
      <PopUpBitcoin
        openProp={open}
        setOpen={setOpen}
        okBtnClick={changeProfile}
        icon={"restartIcon"}
        resourceText={UmbracoUtills.getValueByKey(resourcePopUp, "text")}
        changeProfileBtn={UmbracoUtills.getValueByKey(
          resourcePopUp,
          "changeProfile"
        )}
        changeAfikBtn={UmbracoUtills.getValueByKey(resourcePopUp, "changeAfik")}
      />
    </Row>
  );
}
